import { render, staticRenderFns } from "./img-cropper.vue?vue&type=template&id=6235d87b&"
import script from "./img-cropper.vue?vue&type=script&lang=js&"
export * from "./img-cropper.vue?vue&type=script&lang=js&"
import style0 from "./img-cropper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports